import { Redirect, navigate, redirectTo } from '@reach/router';
import { parse } from 'query-string';
import React, {
  FormEvent,
  KeyboardEvent,
  PureComponent,
  RefObject,
  createRef,
} from 'react';
import Recaptcha from 'react-google-recaptcha';
import { MapDispatchToProps, MapStateToProps, connect } from 'react-redux';
import {
  IDomainPortObject,
  getAppTitle,
  getDomainAndPort,
  isOutPatientDomain,
} from 'api/Utils';
import { RootState } from 'store/store';
import { phoneNumberPattern, phoneNumberRegex } from 'store/entity/patterns';
import {
  englishNumber,
  persianDigits,
  convertDigitToProperFormat,
} from 'utils/number';
import Button from 'components/Button';
import { display } from 'components/ErrorView/ErrorDialog';
import ErrorView from 'components/ErrorView/ErrorView';
import Input from 'components/Input';
import notify from 'components/Notify';
import { withTranslation } from 'react-i18next';
import messages from './messages';
import {
  ButtonsWrapper,
  TextButton,
  EmailPanel,
  Form,
  Header,
  Hint,
  HintBox,
  InputWrapper,
  LineBetweenButtons,
  LoginCardBack,
  RastechLogo,
  SendCodeText,
  ShadowInput,
  SignUp,
  Title,
} from './styles';
import logo from 'assets/images/rastech-logo.png';
import { openCloseLoginModal } from 'store/loginModal/LoginModalSlice';
import { HintText } from './styles';
import {
  ILoginCardDispatchToProps,
  ILoginCardOwnProps,
  ILoginCardProps,
  ILoginCardState,
  ILoginCardStateToProps,
  LoginType,
} from './LoginCard-type';
import Icon from '../../../components/Icon';
import { appDispatch } from 'store/store';
import { requireUser, updateUser } from 'store/users/usersSlice';
import { IUser } from 'store/users/usersType';
import {
  authenticate2FA,
  changeUserName,
  enterWithSingleAccessCode,
  logoutUser,
  registerWithUsernameAndPassword,
  setSentPhoneNumber,
} from 'store/thisUser/thisUserSlice';
import cloneDeep from 'lodash/cloneDeep';
import JWTLogin from '../../LoginPageNew/JWTLogin';
import UserMixpanel from '../../../utils/mixpanel/MixpanelClass';
import LocalIcon from '../../../ui/LocalIcon';
import { withTheme } from 'styled-components';
import { black, red } from '../../../utils/style/colors';
import TourClearer from './TourClearer';

const AnyRecaptcha: any = Recaptcha; // TODO send PR for style prop

const pleaseEnterCodeSentTo = (phone: string, lng = 'fa') => {
  return lng === 'fa' ? (
    <SendCodeText>
      لطفاً کد ارسال شده به شماره‌ی{' '}
      <div style={{ display: 'inline-block', direction: 'ltr' }}>
        {convertDigitToProperFormat(phone)}
      </div>{' '}
      را وارد کنید.
    </SendCodeText>
  ) : (
    <SendCodeText>
      Please enter the code which was sent to the{' '}
      <div style={{ display: 'inline-block', direction: 'ltr' }}>{phone}</div>
    </SendCodeText>
  );
};

class LoginCard extends PureComponent<ILoginCardProps, ILoginCardState> {
  private domainAndReport: IDomainPortObject;

  public constructor(props: ILoginCardProps) {
    super(props);

    this.domainAndReport = getDomainAndPort();
    const { loginProps } = this.domainAndReport;

    this.state = {
      loading: false,
      loginType:
        (loginProps || {}).defaultView === 'username' ? 'email' : 'phoneNumber',
      loginPanel:
        (loginProps || {}).defaultView === 'username'
          ? 'loginWithEmail'
          : 'enterPhoneNumber',
      phoneNumber: '',
      activeLanguage: this.props.i18n.language,
      appTitle: getAppTitle(),
      showPassword: false,
    };
  }

  username: RefObject<HTMLInputElement> = createRef();
  name: RefObject<HTMLInputElement> = createRef();
  password: RefObject<HTMLInputElement> = createRef();
  reCaptcha: any = createRef();
  codeNumber: RefObject<HTMLInputElement> = createRef();
  registerUsername: RefObject<HTMLInputElement> = createRef();
  registerPassword: RefObject<HTMLInputElement> = createRef();
  registerPassword2: RefObject<HTMLInputElement> = createRef();
  rememberMe: RefObject<HTMLInputElement> = createRef();

  componentDidUpdate(prevState: any) {
    if (prevState.activeLanguage !== this.state.activeLanguage) {
      this.setState({
        appTitle: getAppTitle(),
      });
    }
  }

  componentDidMount() {
    (window as any).recaptchaOptions = {
      lang: 'fa',
    };
    const { location } = window;
    const { homeProfile } = this.domainAndReport;
    const { thisUser, usageType = 'loginPage' } = this.props;
    const parsed: any = parse(location?.search ?? '');

    if (thisUser.isLoggedIn && location && parsed.type !== 'AccessDenied') {
      const isRequireServiceAndLooksLikeItsNot =
        parse(location.search).type === 'service' &&
        !thisUser!.name!.includes('نماینده');

      if (usageType === 'loginPage') {
        const useCurrent = isRequireServiceAndLooksLikeItsNot
          ? !confirm(this.props.t('requireServiceAccount'))
          : confirm(
              this.props.t('alreadyLoggedInWith', { name: thisUser.name })
            );
        if (!useCurrent) {
          this.setState({
            loginPanel:
              parse(location.search).type === 'service'
                ? 'loginWithEmail'
                : 'enterPhoneNumber',
            loginType:
              parse(location.search).type === 'service'
                ? 'email'
                : 'phoneNumber',
          });
          return;
        }
      } else {
        this.setState({
          phoneNumber: thisUser.phone?.replace(/^0098/, '0'),
          username: thisUser.phone?.replace(/^0098/, '0') || thisUser!.email!,
        });
      }

      if (parsed.redirect) {
        redirectTo(parsed.redirect);
      } else {
        if (usageType === 'loginPage') {
          redirectTo(homeProfile ? '/homepage' : '/homepage');
        }
      }
    }

    // this.showAnimation();
  }

  showAnimation() {
    setTimeout((): void => {
      this.setState({
        showAnimation: true,
      });
    }, 2000);
  }

  handleBack() {
    navigate('/content');
  }

  activeDryRun = (e: KeyboardEvent<HTMLFormElement>) => {
    // press CTRL+ALT+SHIFT+D to use dryRun
    if (e.ctrlKey && e.shiftKey && e.altKey && e.which === 68) {
      this.onPhoneSubmit(e, true);
    }
  };

  handleNameSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { user } = this.props;
    if (!user) return;
    this.setState({ loading: true });
    const updatedUser: any = cloneDeep(user);
    updatedUser.name = this.name.current!.value;
    this.props.updateUserInfo(updatedUser).then(() => {
      this.setState({ loading: false });
      this.afterLogin();
    });
  };

  onLoginWithUserPass = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ loading: true });
    const username = this.username.current;
    const password = this.password.current;
    const staySignedIn = this.rememberMe.current;

    if (username && password && staySignedIn) {
      let email: string | null = null;
      let phoneNumber: string | null = null;
      if (username.value.includes('@')) email = username.value;
      else phoneNumber = this.getInternationalPhone(username.value).phoneNumber;

      this.props
        .authenticate2FA(
          phoneNumber,
          email,
          password.value,
          staySignedIn.checked,
          false
        )
        .then(({ data }) => {
          if (data.authInfo) return this.afterLogin();
          else {
            this.setState({
              loginType: 'phoneNumber',
              loginPanel: 'getVerificationCode',
              loginToken: data.phoneAuth.publicPart,
              loading: false,
              phoneNumber: phoneNumber || data.phoneAuth.phone,
              error: undefined,
            });
            return Promise.resolve();
          }
        })
        .catch((err: any) => {
          this.setState({ passError: err, loading: false });
        });
    }
  };

  onRegisterWithUserPass = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ loading: true });

    const username = this.registerUsername.current;
    const password = this.registerPassword.current;
    const password2 = this.registerPassword2.current;
    const reCaptcha = this.reCaptcha.current.getValue();

    if (username && password && password2) {
      if (password.value !== password2.value) {
        this.setState({
          registerError: {
            code: 400,
            data: {
              message: 'password.not.unique',
              status: 'failed',
            },
          },
          loading: false,
        });
        return;
      }

      try {
        await this.props.registerWithUsernameAndPassword(
          username.value,
          password.value,
          reCaptcha
        );
        await this.afterLogin();
      } catch (err: any) {
        this.reCaptcha.current.reset();
        this.setState({ loading: false, registerError: err.message });
      }
    }
  };

  afterLogin = async () => {
    const { location } = window;
    const { thisUser, usageType = 'loginPage' } = this.props;
    const { loginProps, homeProfile } = this.domainAndReport;
    const mx = UserMixpanel.getInstance(+thisUser.userId!);

    return this.props
      .requireUser(Number(thisUser.userId))
      .then(({ user }) => {
        if (usageType === 'loginPage') {
          if (
            (user.name || (loginProps && loginProps.dontAskName)) &&
            location
          ) {
            mx.setUsersInfo(user.name, user.email, user.phone);
            user.name && this.props.changeUserName(user.name);
            const parsed: any = parse(location.search);

            if (parsed.redirect && parsed.redirect.startsWith('/')) {
              navigate(parsed.redirect, { replace: true });
            } else {
              navigate(homeProfile ? '/homepage' : '/homepage');
            }
          } else {
            this.setState({ loginPanel: 'setName', loginType: 'phoneNumber' });
          }
        }
        this.props.openCloseLoginModal(false);
        this.setState({ loading: false });
      })
      .catch((err: any) => {
        this.setState({ loading: false });
        display(err);
      });
  };

  handleCodeSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ loading: true });
    const loginToken = this.state.loginToken;
    const codeNumber = this.codeNumber.current;
    const staySignedIn = this.rememberMe.current;

    if (loginToken && codeNumber && staySignedIn) {
      this.props
        .enterWithSingleAccessCode(
          loginToken,
          englishNumber(codeNumber.value),
          staySignedIn.checked
        )
        .then(() => {
          this.afterLogin();
        })
        .catch((err: any) => {
          this.setState({ error: err, loading: false });
        });
    }
  };

  preventKeys = (e: React.KeyboardEvent) => {
    const forbiddenKeys = [32, 43, 45]; // [space, plus, hyphen]
    if (forbiddenKeys.includes(e.which)) {
      e.preventDefault();
      return false;
    }
    return;
  };

  onChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const phoneNumber = englishNumber(inputValue);
    if (!isNaN(Number(phoneNumber))) {
      this.setState({ phoneNumber: inputValue });
    }
  };

  handlePastePhoneNumber = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedValue = e.clipboardData.getData('Text');
    const isPersian = pastedValue.split('').some((char) => {
      return persianDigits.includes(char);
    });
    // get only digits from pasted text
    let phoneNumber = englishNumber(pastedValue).replace(/\D/g, '');
    const isMatch = phoneNumberRegex.test(phoneNumber);

    if (isPersian) {
      phoneNumber = convertDigitToProperFormat(phoneNumber);
    }
    if (!isMatch) {
      notify(this.props.t('phoneNumberNotMatch'), 'warning');
    }
    this.setState({ phoneNumber });
  };

  onPhoneSubmit = (
    e: FormEvent<HTMLFormElement> | KeyboardEvent<HTMLFormElement>,
    dryRun?: boolean
  ) => {
    e.preventDefault();
    this.setState({ error: undefined, loading: true });
    if (this.state.phoneNumber!.length > 0) {
      const { inputValue, phoneNumber } = this.getInternationalPhone(
        this.state.phoneNumber!
      );
      this.props.authenticate2FA(phoneNumber, null, null, false, !!dryRun).then(
        ({ data }) => {
          this.props.setSentPhoneNumber(phoneNumber);
          this.setState({
            loginToken: data.phoneAuth.publicPart,
            loginPanel: 'getVerificationCode',
            loading: false,
            error: undefined,
          });
        },
        (err) => {
          if (err.data.message === 'require2fa')
            this.setState({
              username: inputValue,
              loginType: 'email',
              loginPanel: 'loginWithEmail',
            });
          this.setState({
            phoneError: err,
            loading: false,
          });
        }
      );
    }
  };

  private getInternationalPhone(input: string) {
    const inputValue = englishNumber(input);
    const inputLength = inputValue.length;
    const slicedNumber = inputValue.slice(inputLength - 10, inputLength);
    const phoneNumber = `0098${slicedNumber}`;
    return { inputValue, phoneNumber };
  }

  changeLoginType = (type: LoginType) => () => {
    this.setState({
      loginType: type,
      loginPanel:
        type === 'phoneNumber' ? 'enterPhoneNumber' : 'loginWithEmail',
      username: type === 'email' ? this.state.phoneNumber : this.state.username,
    });
  };

  goGetPhoneNumber = () => {
    this.setState({ loginPanel: 'enterPhoneNumber' });
  };

  showSignUpEmailPanel = () => {
    this.setState({ loginPanel: 'signUpWithEmail' });
  };

  showLoginEmailPanel = () => {
    this.setState({ loginPanel: 'loginWithEmail' });
  };

  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const {
      error,
      loading,
      loginType,
      loginPanel,
      passError,
      phoneError,
      registerError,
      username,
      redirect,
      // showAnimation,
    } = this.state;
    const { t, i18n, thisUser, usageType, logoutUser, theme } = this.props;
    const { loginProps } = this.domainAndReport;
    const token = this.props.token;
    const lng = i18n.language;

    if (redirect) {
      return <Redirect to={redirect} />;
    }

    let { type } = parse(window.location.search);
    const { message } = parse(window.location.search);

    if (type === 'AccessDenied' && thisUser.isLoggedIn) {
      type = 'AccessDenied_withLogin';
    }
    if (usageType === 'loginModal') type = 'loginAgain';

    const now = new Date();
    const isYalda =
      now.getMonth() === 11 && now.getDate() < 24 && now.getDate() > 16;
    let loginPageTitle = t('getLoginPageTitle', { title: this.state.appTitle });
    const isNewYear = now.getMonth() === 2 && now.getDate() > 15;
    const isRamazan = now.getMonth() === 2 && now.getDate() > 10 && !isNewYear; // valid for 1402
    const finalLogo = (loginProps && loginProps.logo) || logo;
    const forcePhone = usageType === 'loginModal' && thisUser.phone;
    const forceEmail =
      usageType === 'loginModal' && (thisUser.phone || thisUser.email);
    if (isYalda) {
      loginPageTitle = t('happyYalda');
    } else if (isNewYear) {
      loginPageTitle = ' ';
      // finalLogo = undefined;

      if (!type) {
        type = 'newYearNote';
      }
    } else if (isRamazan) {
      loginPageTitle = t('happyRamazan');
    }

    return (
      <LoginCardBack loginModal={usageType === 'loginModal'}>
        <TourClearer />
        <Header>
          {finalLogo && <RastechLogo src={finalLogo} alt="rastech" />}
          <Title smaller={loginPageTitle.length > 25}>{loginPageTitle}</Title>
        </Header>

        {token && token !== '' ? (
          <JWTLogin token={token} afterLogin={this.afterLogin} />
        ) : (
          <>
            {/*{loginPanel === 'signUpWithEmail' ? null : (
          <LoginText showAnimation={showAnimation}>
            <p>
              <b>{t(anniversaryBoldTitle}</b> {t(anniversaryTitle}
            </p>
            {t(anniversaryText}
          </LoginText>
        )}*/}
            {(type && messages[type as string]) ||
            message ||
            type === 'AccessDenied_withLogin' ? (
              <HintBox>
                <HintText>
                  <span>
                    {type === 'AccessDenied_withLogin' && thisUser?.name
                      ? t('accessDeniedWith', {
                          name: thisUser.name,
                          ns: 'login',
                        })
                      : t(`${type}`)}
                    {message || ''}
                  </span>
                </HintText>
              </HintBox>
            ) : (
              loginProps &&
              loginProps.infoTitle && (
                <HintBox>
                  {/*<HintIcon type="info" />*/}
                  <HintText>
                    <span>
                      {loginProps.infoTitle}
                      {loginProps.infoLink && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={loginProps.infoLink || ''}
                        >
                          {loginProps.infoLinkTitle || ''}
                        </a>
                      )}
                    </span>
                  </HintText>
                </HintBox>
              )
            )}
            <div className="section">
              {loginType === 'phoneNumber' ? (
                <div>
                  {loginPanel === 'enterPhoneNumber' ? (
                    <Form
                      onSubmit={this.onPhoneSubmit}
                      onKeyUp={this.activeDryRun}
                    >
                      <ErrorView err={phoneError} />
                      <InputWrapper>
                        <LocalIcon
                          iconName="mobile.svg"
                          color={black}
                          style={{ marginInlineEnd: '0.5rem' }}
                          type="lg"
                        />
                        <ShadowInput
                          id="phoneNumber"
                          type="tel"
                          disabled={!!forcePhone}
                          maxLength={14}
                          pattern={phoneNumberPattern}
                          value={this.state.phoneNumber}
                          required={true}
                          onPaste={this.handlePastePhoneNumber}
                          onChange={this.onChangePhoneNumber}
                          onKeyPress={this.preventKeys}
                          placeholder={t('phoneNumber')}
                          autoComplete="off"
                        />
                      </InputWrapper>
                      <ButtonsWrapper>
                        <Button color="black" type="submit" loading={loading}>
                          {t('getCode')}
                        </Button>
                        {!isOutPatientDomain() && (
                          <>
                            <LineBetweenButtons />
                            <Button
                              color="white"
                              onClick={this.changeLoginType('email')}
                            >
                              {t('loginWithEmail')}
                            </Button>
                          </>
                        )}
                      </ButtonsWrapper>
                    </Form>
                  ) : loginPanel === 'setName' ? (
                    <Form onSubmit={this.handleNameSubmit}>
                      <div style={{ textAlign: 'center', color: black }}>
                        {t('enterYourName')}
                      </div>
                      <ErrorView err={error} />
                      <InputWrapper>
                        <LocalIcon
                          iconName="user.svg"
                          color={error ? red : black}
                          style={{ marginInlineEnd: '0.5rem' }}
                        />
                        <ShadowInput
                          style={{ direction: theme.direction }}
                          id="name"
                          type="text"
                          ref={this.name}
                          value={this.state.name || ''}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            this.setState({ name: e.target.value })
                          }
                          required={true}
                          placeholder={t('name')}
                          autoComplete="name"
                          defaultValue={''}
                        />
                      </InputWrapper>
                      <ButtonsWrapper>
                        <Button type="submit" color="black" loading={loading}>
                          {t('submit')}
                        </Button>
                      </ButtonsWrapper>
                    </Form>
                  ) : (
                    <Form onSubmit={this.handleCodeSubmit}>
                      <div style={{ textAlign: 'center' }}>
                        {pleaseEnterCodeSentTo(
                          `${this.state.phoneNumber!}`,
                          lng
                        )}
                      </div>
                      <ErrorView err={error} />
                      <InputWrapper>
                        <LocalIcon
                          iconName="sms.svg"
                          style={{ marginInlineEnd: '0.5rem' }}
                          color={error ? red : black}
                        />
                        <ShadowInput
                          id="codeNumber"
                          type="tel"
                          maxLength={5}
                          ref={this.codeNumber}
                          required={true}
                          placeholder={t('code')}
                          autoComplete="one-time-code"
                          err={error}
                        />
                      </InputWrapper>
                      <Input
                        type="checkbox"
                        id="rememberMe"
                        name="rememberMe"
                        label={t('rememberMe')}
                        forwardRef={this.rememberMe}
                        wrapperClassName="center-vh"
                        defaultChecked={true}
                      />
                      <ButtonsWrapper>
                        <Button type="submit" color="black" loading={loading}>
                          {t('submit')}
                        </Button>
                        <LineBetweenButtons />
                        <Button
                          type="button"
                          color="white"
                          onClick={this.goGetPhoneNumber}
                        >
                          {t('goBack')}
                        </Button>
                      </ButtonsWrapper>
                    </Form>
                  )}
                </div>
              ) : (
                <div>
                  <EmailPanel id="login" show={loginPanel === 'loginWithEmail'}>
                    <Form onSubmit={this.onLoginWithUserPass}>
                      <ErrorView err={passError} />
                      <InputWrapper>
                        <LocalIcon
                          iconName="user.svg"
                          color={passError ? red : black}
                          style={{ marginInlineEnd: '0.5rem' }}
                        />
                        <ShadowInput
                          id="username"
                          ref={this.username}
                          type="text"
                          disabled={!!forceEmail}
                          autoComplete="email"
                          required={true}
                          value={username}
                          onChange={(event: any) => {
                            this.setState({
                              username: event.target.value?.replace(/\s+/g, ''),
                            });
                          }}
                          placeholder={t('emailOrPhone')}
                          err={passError}
                          style={{
                            marginBottom: '0',
                            border: '1px solid gray',
                          }}
                        />
                      </InputWrapper>
                      <InputWrapper>
                        <LocalIcon
                          iconName="password.svg"
                          color={passError ? red : black}
                          style={{ marginInlineEnd: '0.5rem' }}
                        />
                        <ShadowInput
                          id="password"
                          ref={this.password}
                          type={this.state.showPassword ? 'text' : 'password'}
                          required={true}
                          placeholder={t('password')}
                          autoComplete="current-password"
                          err={passError}
                        />

                        <LocalIcon
                          iconName={
                            this.state.showPassword ? 'eye-off.svg' : 'eye.svg'
                          }
                          color={black}
                          style={{
                            marginInlineStart: '0.5rem',
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '0.25rem',
                          }}
                          onClick={this.togglePasswordVisibility}
                        />
                      </InputWrapper>
                      <Input
                        id="rememberMe"
                        type="checkbox"
                        name="rememberMe"
                        forwardRef={this.rememberMe}
                        label={t('rememberMe')}
                        wrapperClassName="center-vh"
                        defaultChecked={true}
                      />
                      {(!loginProps || !loginProps.preventRegister) &&
                        usageType !== 'loginModal' && (
                          <SignUp>
                            <Hint>{t('newUser')}</Hint>
                            <Hint>
                              <TextButton onClick={this.showSignUpEmailPanel}>
                                {t('register')}
                              </TextButton>
                            </Hint>
                          </SignUp>
                        )}
                      <ButtonsWrapper>
                        <Button type="submit" color="black" loading={loading}>
                          {t('enter')}
                        </Button>
                        <LineBetweenButtons />
                        <Button
                          color="white"
                          onClick={this.changeLoginType('phoneNumber')}
                        >
                          {t('loginWithPhone')}
                        </Button>
                      </ButtonsWrapper>
                    </Form>
                  </EmailPanel>
                  <EmailPanel
                    id="register"
                    show={loginPanel === 'signUpWithEmail'}
                  >
                    <Form onSubmit={this.onRegisterWithUserPass}>
                      <div>
                        <ErrorView err={registerError} />
                        <InputWrapper>
                          <LocalIcon
                            iconName="user-no-border.svg"
                            color={registerError ? red : black}
                            style={{
                              marginInlineEnd: '0.5rem',
                            }}
                          />
                          <ShadowInput
                            id="registerUsername"
                            type="text"
                            ref={this.registerUsername}
                            required={true}
                            autoComplete="off"
                            placeholder={t('email')}
                            err={registerError}
                            style={{
                              marginBottom: '0.5rem',
                              border: '1px solid gray',
                            }}
                          />
                        </InputWrapper>
                        <InputWrapper>
                          <LocalIcon
                            iconName="password.svg"
                            color={registerError ? red : black}
                            style={{ marginInlineEnd: '0.5rem' }}
                          />
                          <ShadowInput
                            id="registerPassword"
                            type="password"
                            ref={this.registerPassword}
                            required={true}
                            placeholder={t('password')}
                            autoComplete="new-password"
                            err={registerError}
                          />
                        </InputWrapper>
                        <InputWrapper>
                          <LocalIcon
                            iconName="password.svg"
                            color={registerError ? red : black}
                            style={{ marginInlineEnd: '0.5rem' }}
                          />
                          <ShadowInput
                            id="registerPassword2"
                            type="password"
                            ref={this.registerPassword2}
                            required={true}
                            placeholder={t('password2')}
                            autoComplete="new-password"
                            err={registerError}
                          />
                        </InputWrapper>
                        <AnyRecaptcha
                          ref={this.reCaptcha}
                          sitekey="6LdhgEMUAAAAANlZOvlLciJOXTjIds8PF5OkVpzu"
                          style={{
                            margin: '0.4rem 0',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        />
                      </div>
                      <SignUp>
                        <Hint>{t('hasRegister')}</Hint>
                        <Hint>
                          <TextButton onClick={this.showLoginEmailPanel}>
                            {t('enterToLogin')}
                          </TextButton>
                        </Hint>
                      </SignUp>
                      <ButtonsWrapper>
                        <Button type="submit" color="black" loading={loading}>
                          {t('register')}
                        </Button>
                        <LineBetweenButtons />
                        <Button
                          color="white"
                          onClick={this.changeLoginType('phoneNumber')}
                        >
                          {t('loginWithPhone')}
                        </Button>
                      </ButtonsWrapper>
                    </Form>
                  </EmailPanel>
                </div>
              )}
              {usageType === 'loginModal' && (
                <ButtonsWrapper>
                  <Button
                    type="button"
                    color="red"
                    disabled={loading}
                    onClick={() => logoutUser()}
                  >
                    <Icon type="log-out" />
                    {t('switchUser')}
                  </Button>
                </ButtonsWrapper>
              )}
            </div>
          </>
        )}
      </LoginCardBack>
    );
  }
}

const mapStateToProps: MapStateToProps<
  ILoginCardStateToProps,
  ILoginCardOwnProps,
  RootState
> = (state) => {
  const userId = Number(state.thisUser.userId);
  const user = state.users.map[userId];
  const thisUser = state.thisUser;

  return { userId, user, thisUser };
};

const mapDispatchToProps: MapDispatchToProps<
  ILoginCardDispatchToProps,
  ILoginCardOwnProps
> = () => {
  return {
    requireUser: (userId: number) => appDispatch(requireUser({ userId })),
    logoutUser: () => appDispatch(logoutUser({ shouldRedirect: true })),
    updateUserInfo: (user: IUser) => appDispatch(updateUser({ user })),
    enterWithSingleAccessCode: (
      loginToken: string,
      codeNumber: string,
      staySignedIn: boolean
    ) =>
      appDispatch(
        enterWithSingleAccessCode({ loginToken, codeNumber, staySignedIn })
      ),
    authenticate2FA: (
      phone: string | null,
      email: string | null,
      password: string | null,
      staySignedIn: boolean = false,
      dryRun: boolean = false
    ) =>
      appDispatch(
        authenticate2FA({ phone, email, password, staySignedIn, dryRun })
      ),
    registerWithUsernameAndPassword: (
      username: string,
      password: string,
      captcha: string
    ) =>
      appDispatch(
        registerWithUsernameAndPassword({ username, password, captcha })
      ),
    changeUserName: (userName: string) =>
      appDispatch(changeUserName({ name: userName })),
    setSentPhoneNumber: (phone: string) =>
      appDispatch(setSentPhoneNumber({ phone })),
    openCloseLoginModal: (isOpen?: boolean) =>
      appDispatch(openCloseLoginModal(isOpen)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('login')(withTheme(LoginCard)));
